import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-exclamationNew",
  "use": "icon-exclamationNew-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-exclamationNew\"><path d=\"M957.6 872l-432-736c-3.2-5.6-8.8-8-13.6-8s-10.4 2.4-13.6 8l-432 736C60 882.4 68 896 80 896h864c12 0 20-13.6 13.6-24zM164 832l348-592.8L860 832H164z m316-128h64v64h-64v-64z m0-320h64v256h-64V384z\" p-id=\"15558\" fill=\"#FC6030\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol